import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/lib/locale/lang/pt-br'

export default (app) => {
  app.use(ElementPlus, { locale, size: "small" })
}
